/**
 * ICON STANDARDS - DO NOT MODIFY
 *
 * This file contains all standardized icons used across the Alert Services application.
 * These icon standards ensure visual consistency throughout the entire interface.
 *
 * RULES:
 * 1. All components MUST import icons from this file, not directly from @mui/icons-material
 * 2. Icon sizes are standardized and should not be changed without updating this file
 * 3. Never use different icon variants for the same purpose across different components
 */

import React from "react";
import {
  // Navigation & Actions
  KeyboardArrowDown,
  KeyboardArrowUp,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  ExpandMore,
  ExpandLess,

  // Common Actions
  Search,
  Close,
  Add,
  Edit,
  Delete,
  Refresh,
  MoreVert,
  CheckCircle,
  Cancel,
  Info,

  // Date & Time
  CalendarToday,
  AccessTime,

  // Media
  Videocam,

  // Notifications
  Notifications,
  NotificationsActive,

  // Data & Files
  FileDownload,

  // Security & IoT
  Sensors,

  // View Options
  ViewList,
  ViewModule,
  FilterList,

  // Settings
  Settings,
} from "@mui/icons-material";

// Import custom Figma dropdown icon
import FigmaArrowDropDown from "../imports/ArrowDropDown";

/**
 * STANDARDIZED ICON COMPONENTS
 * Import these components in your files instead of importing from @mui/icons-material
 */

// Custom Dropdown Icon Component - Used for all Select/Dropdown components
export const DropdownIcon = React.forwardRef((props, ref) => {
  return (
    <div
      ref={ref}
      style={{
        width: "20px",
        height: "20px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...props.style,
      }}
      className={props.className}
    >
      <FigmaArrowDropDown />
    </div>
  );
});

DropdownIcon.displayName = "DropdownIcon";

export const DROPDOWN_ICON_SIZE = 20;

// Calendar Icon
export const CalendarIcon = CalendarToday;
export const CALENDAR_ICON_SIZE = 20;

// Search Icon
export const SearchIcon = Search;
export const SEARCH_ICON_SIZE = 20;

// Close Icon
export const CloseIcon = Close;
export const CLOSE_ICON_SIZE = 20;

// Add Icon
export const AddIcon = Add;
export const ADD_ICON_SIZE = 20;

// Edit Icon
export const EditIcon = Edit;
export const EDIT_ICON_SIZE = 20;

// Delete Icon
export const DeleteIcon = Delete;
export const DELETE_ICON_SIZE = 20;

// Refresh Icon
export const RefreshIcon = Refresh;
export const REFRESH_ICON_SIZE = 16;

// More Icon
export const MoreIcon = MoreVert;
export const MORE_ICON_SIZE = 20;

// Info Icon
export const InfoIcon = Info;
export const INFO_ICON_SIZE = 16;

// Success Icon
export const SuccessIcon = CheckCircle;
export const SUCCESS_ICON_SIZE = 20;

// Cancel Icon
export const CancelIcon = Cancel;
export const CANCEL_ICON_SIZE = 20;

// Time Icon
export const TimeIcon = AccessTime;
export const TIME_ICON_SIZE = 20;

// Camera Icon
export const CameraIcon = Videocam;
export const CAMERA_ICON_SIZE = 20;

// Notification Icon
export const NotificationIcon = Notifications;
export const NOTIFICATION_ICON_SIZE = 20;

// Notification Active Icon
export const NotificationActiveIcon = NotificationsActive;
export const NOTIFICATION_ACTIVE_ICON_SIZE = 20;

// Download Icon
export const DownloadIcon = FileDownload;
export const DOWNLOAD_ICON_SIZE = 20;

// IoT Sensor Icon
export const SensorIcon = Sensors;
export const SENSOR_ICON_SIZE = 20;

// Expand / Collapse Icons
export const ExpandIcon = ExpandMore;
export const CollapseIcon = ExpandLess;
export const EXPAND_ICON_SIZE = 20;

// Arrow Icons
export const ArrowDownIcon = KeyboardArrowDown;
export const ArrowUpIcon = KeyboardArrowUp;
export const ArrowLeftIcon = KeyboardArrowLeft;
export const ArrowRightIcon = KeyboardArrowRight;
export const ARROW_ICON_SIZE = 20;

// View Mode Icons
export const ViewListIcon = ViewList;
export const ViewModuleIcon = ViewModule;
export const VIEW_MODE_ICON_SIZE = 20;

// Filter Icon
export const FilterListIcon = FilterList;
export const FILTER_ICON_SIZE = 20;

// Settings Icon
export const SettingsIcon = Settings;
export const SETTINGS_ICON_SIZE = 20;
